<div style="padding: {{padding}} 0">
  <hr class="theme-hr {{classLine}}" style="height: {{height}}"/>
</div>

